import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/memo_detail.js';
import { shareColumnsExtend } from './share';
export const filterColumns = {
  content_cont: {
    model_name: 'Memo',
    column_type: 'string',
    column_name: 'content',
  },
}
export const formColumnsConfig = {
  'self': {
    'remind_at': { required: true, disabledUpdate: false },
    'content': { required: true, disabledUpdate: false },
    'customer_id': { required: false, disabledUpdate: false },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('Memo', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('Memo', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
